import { Avatar } from "@mantine/core";

const ChevronLeftIcon = ({ size }: any) => {
  return (
    <Avatar
      style={{
        cursor: "pointer",
      }}
      size={size}
      src={"/assets/chevronLeft.png"}
    />
  );
};

export default ChevronLeftIcon;
